import {
  ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__SUCCESS,
  ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__REQUEST,
  ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__REQUEST:
    case ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__SUCCESS:
      return null;

    case ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
